const createMarketHistoryApi = ({ marketHistoryMonitor, }) => {
    return {
        marketHistory: {
            update: marketHistoryMonitor.update,
            updateAll: marketHistoryMonitor.updateAll,
            fetchAssetPricesFromDate: marketHistoryMonitor.fetchAssetPricesFromDate,
        },
    };
};
const marketHistoryApiDefinition = {
    id: 'marketHistoryApi',
    type: 'api',
    factory: createMarketHistoryApi,
    dependencies: ['marketHistoryMonitor'],
};
export default marketHistoryApiDefinition;
